// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconX } from "../../components/icons.jsx";
export const jb = "_page_1bbdo_1";
export const xb = "_dialog_1bbdo_2";
export const Sb = "_hero_1bbdo_5";
export const wb = "_heading_1bbdo_6";
export const Nb = "_headingLine_1bbdo_8";
export const Tb = "_rating_1bbdo_9";
export const Cb = "_deckPanel_1bbdo_11";
export const Mb = "_sectionTitle_1bbdo_12";
export const Ab = "_deck_1bbdo_11";
export const Eb = "_slot_1bbdo_17";
export const Db = "_slotFrame_1bbdo_18";
export const zb = "_slotNumber_1bbdo_22";
export const Ob = "_cardOrnament_1bbdo_23";
export const kb = "_basic_1bbdo_24";
export const Rb = "_advanced_1bbdo_24";
export const Bb = "_elite_1bbdo_24";
export const Ub = "_majestic_1bbdo_24";
export const Hb = "_absolute_1bbdo_24";
export const Lb = "_limited_1bbdo_24";
export const qb = "_mystic_1bbdo_24";
export const Gb = "_emptySlot_1bbdo_25";
export const Yb = "_deckHint_1bbdo_30";
export const Xb = "_media_1bbdo_31";
export const Qb = "_mediaFallback_1bbdo_33";
export const Zb = "_videoBadge_1bbdo_35";
export const Vb = "_power_1bbdo_36";
export const $b = "_actions_1bbdo_38";
export const Kb = "_secondaryButton_1bbdo_39";
export const Jb = "_primaryButton_1bbdo_39";
export const Wb = "_dangerButton_1bbdo_39";
export const Ib = "_battleButton_1bbdo_42";
export const Fb = "_stats_1bbdo_44";
export const Pb = "_history_1bbdo_45";
export const eg = "_error_1bbdo_46";
export const tg = "_sheet_1bbdo_48";
export const ag = "_sheetHeader_1bbdo_48";
export const lg = "_iconButton_1bbdo_48";
export const ng = "_currentCard_1bbdo_49";
export const sg = "_currentArt_1bbdo_49";
export const ig = "_currentActions_1bbdo_49";
export const cg = "_pickerHint_1bbdo_50";
export const ug = "_search_1bbdo_50";
export const og = "_filters_1bbdo_51";
export const rg = "_sortNote_1bbdo_51";
export const dg = "_pickerGrid_1bbdo_52";
export const fg = "_choice_1bbdo_52";
export const hg = "_choiceInfo_1bbdo_52";
export const mg = "_preview_1bbdo_53";
export const pg = "_backButton_1bbdo_53";
export const vg = "_previewArt_1bbdo_53";
export const bg = "_largeMedia_1bbdo_53";
export const gg = "_rarityLabel_1bbdo_53";
export const yg = "_previewStats_1bbdo_53";
export const _g = "_gain_1bbdo_53";
export const jg = "_loss_1bbdo_53";
export const xg = "_muted_1bbdo_53";
export const Sg = "_confirmBody_1bbdo_54";
export const wg = "_confirmInline_1bbdo_54";
export const Ng = "_status_1bbdo_55";
export const Tg = "_emptyState_1bbdo_55";
export const Cg = "_skeleton_1bbdo_55";
export const Mg = "_shimmer_1bbdo_1";
export const de = {
  page: jb,
  dialog: xb,
  hero: Sb,
  heading: wb,
  headingLine: Nb,
  rating: Tb,
  deckPanel: Cb,
  sectionTitle: Mb,
  deck: Ab,
  slot: Eb,
  slotFrame: Db,
  slotNumber: zb,
  cardOrnament: Ob,
  basic: kb,
  advanced: Rb,
  elite: Bb,
  majestic: Ub,
  absolute: Hb,
  limited: Lb,
  mystic: qb,
  emptySlot: Gb,
  deckHint: Yb,
  media: Xb,
  mediaFallback: Qb,
  videoBadge: Zb,
  power: Vb,
  actions: $b,
  secondaryButton: Kb,
  primaryButton: Jb,
  dangerButton: Wb,
  battleButton: Ib,
  stats: Fb,
  history: Pb,
  error: eg,
  sheet: tg,
  sheetHeader: ag,
  iconButton: lg,
  currentCard: ng,
  currentArt: sg,
  currentActions: ig,
  pickerHint: cg,
  search: ug,
  filters: og,
  sortNote: rg,
  pickerGrid: dg,
  choice: fg,
  choiceInfo: hg,
  preview: mg,
  backButton: pg,
  previewArt: vg,
  largeMedia: bg,
  rarityLabel: gg,
  previewStats: yg,
  gain: _g,
  loss: jg,
  muted: xg,
  confirmBody: Sg,
  confirmInline: wg,
  status: Ng,
  emptyState: Tg,
  skeleton: Cg,
  shimmer: Mg
};
export function ArenaDialog({
  title: u,
  busy: o = !1,
  onClose: m,
  children: r
}) {
  const g = React.useRef(null);
  return React.useEffect(() => {
    const j = g.current;
    j.showModal();
    const B = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      j.close(), document.body.style.overflow = B;
    };
  }, []), jsxRuntime.jsx("dialog", {
    ref: g,
    className: de.dialog,
    "aria-label": u,
    onCancel: j => {
      j.preventDefault(), o || m();
    },
    onClick: j => {
      j.target === j.currentTarget && !o && m();
    },
    children: jsxRuntime.jsxs("div", {
      className: de.sheet,
      children: [jsxRuntime.jsxs("header", {
        className: de.sheetHeader,
        children: [jsxRuntime.jsx("h2", {
          children: u
        }), jsxRuntime.jsx("button", {
          type: "button",
          className: `${de.iconButton} mc-icon-button`,
          "aria-label": "Закрыть",
          disabled: o,
          onClick: m,
          children: jsxRuntime.jsx(IconX, {})
        })]
      }), r]
    })
  });
}
